
//! gelecek tarih bu formatta: 2024-10-02T10:30:17.4646786Z (bu herhangi bir şekilde tarhini değiştirmiyor saat falan eklemiyor olduğu gibi dönüyor)
const dateTimeFormatter = (date) => {

    const dateFormatter = new Intl.DateTimeFormat('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });

    const timeFormatter = new Intl.DateTimeFormat('tr-TR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // 24 saat formatı için
    });

    return {
        date: dateFormatter.format(new Date(date.split(".")[0])), 
        time: timeFormatter.format(new Date(date.split(".")[0])) 
    }
}

export default dateTimeFormatter